export enum BreakpointsEnum {
  xs = 0,
  tn = 370,
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1280,
  hd = 1600,
  fhd = 1920,
  qhd = 2560,
  uhd = 3840
}
